import { Listing, OfferType } from '@smg-real-estate/hg-rets-schema';

export const isListingValidForCrif = (listing: Listing): boolean =>
  listing?.offerType === OfferType.Rent;
